/**
 * Simplified source manager - handles single source without fallback
 */
class SourceManager {
    constructor() {
        this.source = null;
    }

    /**
     * Set the single video source
     */
    setSource(source) {
        this.source = source;

    }

    /**
     * Get the current source
     */
    getCurrentSource() {
        if (!this.source) return null;

        return {
            type: this.source.type,
            url: this.source.url,
            mimetype: this.source.mimetype,
            isHLS: this.source.type === 'fmp4' || this.source.type === 'hls',
        };
    }

    /**
     * Check if current source is HLS/FMP4
     */
    isCurrentSourceHLS() {
        return this.source?.type === 'fmp4' || this.source?.type === 'hls';
    }

    /**
     * Get source URL with initial time fragment (for non-HLS sources only)
     */
    getSourceUrl(initialTime = 0) {
        if (!this.source) return '';


        if (this.source.type === 'fmp4' || this.source.type === 'hls') {
            return this.source.url;
        }


        return `${this.source.url}#t=${initialTime}`;
    }

    /**
     * Reset source
     */
    reset() {
        this.source = null;
    }
}

export default SourceManager;